import React from 'react';
import {PhotoProvider, PhotoView} from 'react-photo-view';
import './PhotoPreviewComponent.scss';
interface PhotoPreviewComponentProps {
  src: any;
  children: any;
}
const PhotoPreviewComponent = (
  props: PhotoPreviewComponentProps
): React.ReactElement => {
  const {src, children} = props;
  return (
    <PhotoProvider>
      <PhotoView src={src}>{children}</PhotoView>
    </PhotoProvider>
  );
};

export default PhotoPreviewComponent;
